import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchDataQuery } from 'api/patchQuery';

export function useAdminPatchApi(userNumber, userRole) {
  const queryClient = useQueryClient();

  const patchUserPasswordMutation = useMutation({
    mutationFn: () => patchDataQuery(`/admin/password?id=${userNumber}`),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['adminUserAll']);
    },
  });

  const patchData = {
    userNumber,
    role: userRole,
  };

  const patchUserRoleMutation = useMutation({
    mutationFn: () => patchDataQuery(`/admin/role`, patchData),
    onSuccess: (data) => {
      queryClient.invalidateQueries(['adminUserAll']);
    },
  });

  return {
    // 유저 패스워드 초기화
    patchUserPasswordMutation,

    // 유저 권한 변경
    patchUserRoleMutation,
  };
}
